const FormContainer = ({children}) => {
    return ( 
        <div className="formContainer">
            {children}
        </div>
     );
}
 
export default FormContainer;